import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import "@/AppExtras.css";
import "@/AdminStyles.css";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminInbox from "@/pages/admin/AdminInbox";
import AuthCallback from "@/pages/admin/AuthCallback";

function AppRoutes() {
  const location = useLocation();
  // Detect Google OAuth return synchronously; playbook: must not run in useEffect.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/enquiries" element={<AdminInbox />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
